// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3buPW","title":"Header_title__2iRSz","side":"Header_side__3BhER"};